import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Modalコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/modal?version=react" target="_blank">こちら</a>
 */
export const Modal = ({ ...props }) => {
    return <View {...props} />
}

Modal.propTypes = {
    /**
     * モーダルの表示非表示
     */
    visible: PropTypes.bool,
    /**
     * モーダルの位置
     */
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'center']),
    /**
     * モーダルのラッパーのスタイル変更用のクラス名
     */
    wrapperClassName: PropTypes.any,
    /**
     * モーダルの幅
     */
    width: PropTypes.number,
    /**
     * タイトル
     */
    title: PropTypes.string,
    /**
     * モーダル内のコンテンツ
     */
    children: PropTypes.node,
    /**
     * モーダル内のフッター
     */
    footer: PropTypes.node,
    /**
     * 閉じるボタン押下時のイベントハンドラー<br>
     * (void) => void
     */
    onCancel: PropTypes.func,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Modal.defaultProps = {
    visible: false,
    placement: 'top',
    width: 928
}
